module.exports = __webpack_public_path__ + "img/patient.5ec663d5.png";